function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 2.5h-1v2h-2v1h2v2h1v-2h2v-1h-2v-2zM5 0C2.24 0 0 2.24 0 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 9C2.795 9 1 7.205 1 5s1.795-4 4-4 4 1.795 4 4-1.795 4-4 4z",
  fill: "#A16855"
});

function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "c79f542a8a1d3d785e943827d71a8be7.svg";
export { SvgPlusCircle as ReactComponent };